import * as React from 'react'

const IconTransfer = (props) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 25'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <defs>
      <path id='icon-sm-transfer_svg__a' d='M0 0h17.595v8.644H0z' />
      <path id='icon-sm-transfer_svg__c' d='M0 0h17.596v8.644H0z' />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <g transform='translate(3.012 3.5)'>
        <mask id='icon-sm-transfer_svg__b' fill='#fff'>
          <use xlinkHref='#icon-sm-transfer_svg__a' />
        </mask>
        <path
          d='M16.099 2.828 5.13 2.81l.252-.254A1.501 1.501 0 0 0 5.378.439L5.374.435a1.5 1.5 0 0 0-2.122.008L.435 3.283A1.5 1.5 0 0 0 .439 5.4c.002 0 .003.003.005.005l2.83 2.805a1.5 1.5 0 0 0 2.117-2.126l-.005-.005-.271-.268 10.977.017a1.5 1.5 0 0 0 .007-3'
          fill='#00B2E3'
          mask='url(#icon-sm-transfer_svg__b)'
        />
      </g>
      <g transform='translate(3 12.513)'>
        <mask id='icon-sm-transfer_svg__d' fill='#fff'>
          <use xlinkHref='#icon-sm-transfer_svg__c' />
        </mask>
        <path
          d='m1.497 5.816 10.969.017-.252.254a1.501 1.501 0 0 0 .004 2.118l.004.004a1.5 1.5 0 0 0 2.122-.008l2.817-2.84a1.5 1.5 0 0 0-.004-2.117c-.002 0-.003-.003-.005-.005L14.322.434a1.5 1.5 0 0 0-2.117 2.126l.005.005.27.268-10.976-.017a1.5 1.5 0 0 0-.007 3'
          fill='#00B2E3'
          mask='url(#icon-sm-transfer_svg__d)'
        />
      </g>
    </g>
  </svg>
)

export default IconTransfer
